import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TitleStrategy, RouterStateSnapshot } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppConfigService } from "../../services/app-config/app-config.service";

@Injectable()
export class TemplateTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private translateService: TranslateService,
    private appConfig: AppConfigService,
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    const titleFinal = this.translateService.instant('pagesTitle.' + title) + ' - ' + this.appConfig.appName;
    if (title !== undefined) {
      this.title.setTitle(titleFinal);
    } else {
      this.title.setTitle(this.appConfig.appName);
    }
  }
}